export default "__VITE_ASSET__7b0fb82a__"